import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import LOgo from '../assets/Ntact.png'
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';
import { sign } from '@tensorflow/tfjs';
// PDF styles
const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 13,
    fontFamily: 'Helvetica',
    flexDirection: 'column',
  },
  header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, borderBottom: '1px solid #ccc', paddingBottom: 8 },
  logo: { width: 90, height: 45, marginBottom: 10 },
  title: { fontSize: 18, fontWeight: 'bold' },
  section: { marginBottom: 12 },
  grid: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12 },
  gridItem: { border: '1px solid #ccc', padding: 6, width: '30%' },
  table: { border: '1px solid #ccc', marginBottom: 12, border: "1px solid #ccc" },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #ccc' },
  tableCell: { borderRight: '1px solid #ccc', padding: 6, flex: 1, textAlign: 'center', fontSize: 11 },
  tableHeader: { backgroundColor: '#f0f0f0', fontWeight: 'bold' },
  note: { border: '1px solid #ccc', padding: 12, marginBottom: 12 },
  checklist: { marginBottom: 12, border: '1px solid #ccc', padding: 12, backgroundColor: '#fff' },
  checklistItem: { flexDirection: 'row', justifyContent: 'space-between', padding: 6, borderBottom: '1px solid #ccc', alignItems: 'center', minHeight: 28 },
  checklistText: { fontSize: 11, fontWeight: 'normal', textTransform: 'uppercase' },
  radioContainer: { flexDirection: 'row', alignItems: 'center' },
  radioButton: { width: 12, height: 12, borderRadius: 6, border: '2px solid #ccc', marginLeft: 5, padding: 1 },
  radioButtonSelected: { backgroundColor: '#28a745' },
  radioText: { fontSize: 10, marginLeft: 5, marginRight: 10 },
  radioButtonSelectedYes: { backgroundColor: '#28a745' },
  radioButtonSelectedNo: { backgroundColor: '#dc3545' },
  comments: { border: '1px solid #ccc', padding: 12, marginBottom: 10, marginTop: 12 },
  signatureGrid: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
  signatureItem: { border: '1px solid #ccc', padding: 8, width: '48%' },
  underline: { borderBottomWidth: 1, borderBottomColor: '#ccc', marginVertical: 5 },
});
const PDFDocument = ({imagesarray, signpreview,   pm_name,
            pm_sign,
            pm_status, fuelAllocation,commentImageArray, driverName, unitNumber, filledDate, logData, safetyChecks, comments, checkedBy, driverSignature }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* Header */}
      <View style={styles.header} wrap={false}>
      <Image src={LOgo} style={styles.logo} />
      <Text style={styles.title}>WEEKLY DRIVER LOG & SAFETY</Text>
        <View style={{ width: 100 }} />
      </View>

{/* ROW 1 : Driver + Date */}
<View style={{ flexDirection: "row", marginBottom: 10 }} wrap={false}>
  {/* Driver */}
  <View style={{ flex: 1, border: "1px solid #9CA3AF", padding: 5 }}>
    <Text style={{ fontWeight: "bold" }}>Driver:</Text>
    <Text>{driverName}</Text>
    <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
  </View>

  {/* Date */}
  <View style={{ flex: 1, border: "1px solid #9CA3AF", padding: 5 }}>
    <Text style={{ fontWeight: "bold" }}>Date:</Text>
    <Text>{filledDate}</Text>
    <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
  </View>
</View>

{/* ROW 2 : Fuel allocation + Unit/Equipment */}
<View style={{ border: "1px solid #9CA3AF", padding: 5 }} wrap={false}>
  <Text style={{ fontWeight: "bold" }}>Fuel Allocation:</Text>
  <Text style={{ textTransform: "capitalize" }}>{fuelAllocation}</Text>

  <View style={{ borderBottom: "1px solid #9CA3AF", marginVertical: 4 }} />

  <Text style={{ fontWeight: "bold" }}>
    {fuelAllocation === "equipment"
      ? "Equipment Description:"
      : "Unit #:"}
  </Text>

  <Text style={{ flexWrap: "wrap" }}>{unitNumber}</Text>

  <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
</View>



      {/* Log Table */}
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.tableHeader]} fixed>
          <Text style={styles.tableCell}>Date</Text>
          <Text style={styles.tableCell}>Mileage Start</Text>
          <Text style={styles.tableCell}>Mileage End</Text>
          <Text style={styles.tableCell}>Job #</Text>
          <Text style={styles.tableCell}>Repair/Fill-up Location</Text>
          <Text style={styles.tableCell}>Gallons Fuel</Text>
          <Text style={styles.tableCell}>Total Amount</Text>
          <Text style={styles.tableCell}>Mileage @ Repair/Fill-up</Text>
        </View>
        {logData.length > 0 ? (
          logData.map((log, index) => (
            <View key={index} style={styles.tableRow} wrap={false}>
              <Text style={styles.tableCell}>{log.date}</Text>
              <Text style={styles.tableCell}>{log.mileage_start}</Text>
              <Text style={styles.tableCell}>{log.mileage_end}</Text>
              <Text style={styles.tableCell}>{log.job_number}</Text>
              <Text style={styles.tableCell}>{log.repair_fillup_location}</Text>
              <Text style={styles.tableCell}>{log.gallons_fuel}</Text>
              <Text style={styles.tableCell}>{log.total_amount}</Text>
              <Text style={styles.tableCell}>{log.mileage_at_repair_fillup}</Text>
            </View>
          ))
        ) : (
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, { flex: 8 }]}>No log data available</Text>
          </View>
        )}
      </View>

      {/* Note Section */}
      <View style={styles.note} wrap={false}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5, fontSize: 13 }}>NOTE:</Text>
        <Text style={{ fontSize: 12 }}>Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.</Text>
      </View>

    </Page>

    {/* ===== PAGE 2: SAFETY CHECKLIST + COMMENTS + SIGNATURES ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>

      {/* Safety Checklist */}
      <View style={styles.checklist}>
        <Text style={{ textAlign: 'center', backgroundColor: '#f0f0f0', padding: 8, marginBottom: 8, fontWeight: 'bold', fontSize: 13 }}>
          WEEKLY CHECK (YES = GOOD CONDITION, NO = REQUIRES A COMMENT)
        </Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
          {[
            'ACCIDENT FORM', 'BATTERY', 'BELTS', 'BRAKE FLUID', 'ENGINE OIL', 'FIRE EXTINGUISHER (10lb)', 'FIRST AID KIT',
            'HEADLAMPS & HI-BEAMS', 'HEATER HOSES', 'HITCH, RECEIVER, AND PINS', 'HORN', 'INSURANCE CARD', 'JACK & TIRE IRON',
            'LIGHTS (Parking & BRAKE)', 'MIRRORS', 'PARKING BRAKE', 'RADIATOR FLUID', 'RADIATOR HOSES', 'SEATBELTS', 'SPARE TIRE',
            'STEERING FLUID', 'TIRE PSI', 'TRANSMISSION OIL', 'TURN SIGNALS', 'WASHER FLUID', 'WINDSHIELD WIPERS',
          ].map((item, index) => (
            <View key={index} style={[styles.checklistItem, { width: '50%', margin: '2px 0px' }]}>
              <Text style={styles.checklistText}>{item}</Text>
              <View style={styles.radioContainer}>
                <Text style={styles.radioText}>YES</Text>
                <View style={[styles.radioButton, safetyChecks[item] === 'Yes' && styles.radioButtonSelectedYes]} />
                <Text style={styles.radioText}>NO</Text>
                <View style={[styles.radioButton, safetyChecks[item] === 'No' && styles.radioButtonSelectedNo]} />
              </View>
            </View>
          ))}
        </View>
      </View>

    </Page>

    {/* ===== PAGE 3: COMMENTS + IMAGES + SIGNATURES ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>

      {/* Comments Section */}
      <View style={styles.comments}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5, fontSize: 13 }}>COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)</Text>
        <Text style={{ fontSize: 12 }}>{comments}</Text>
        <View style={styles.underline} />
      </View>

      {commentImageArray && commentImageArray.length > 0 && (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start', gap: 8, marginTop: 6, marginBottom: 10 }}>
          {commentImageArray.map((x, index) => (
            <View
              key={index}
              style={{
                width: 120,
                height: 70,
                alignItems: 'center',
                justifyContent: 'center',
                borderWidth: 1,
                borderColor: '#D1D5DB',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                marginBottom: 8,
                marginRight: 8,
              }}
            >
              <Image
                source={{ uri: x?.base64_data }}
                style={{ width: 80, height: 65, resizeMode: 'contain', borderRadius: 4 }}
              />
            </View>
          ))}
        </View>
      )}

      {/* Signatures */}
      <View style={styles.signatureGrid}>
        <View style={styles.signatureItem}>
          <Text style={{ fontWeight: 'bold', fontSize: 13 }}>Checked By:</Text>
          <Text style={{ fontSize: 12 }}>{checkedBy}</Text>
          <View style={styles.underline} />
        </View>
        <View style={styles.signatureItem}>
          <Text style={{ fontWeight: 'bold', fontSize: 13 }}>Driver Signature:</Text>
          {imagesarray?.base64_data && (
            <Image
              source={{ uri: imagesarray.base64_data }}
              style={{
                width: 100,
                height: 30,
                resizeMode: 'contain',
                borderWidth: 1,
                borderColor: '#D1D5DB',
                borderRadius: 4,
                backgroundColor: '#fff',
                marginTop: 5,
              }}
            />
          )}
          <View style={styles.underline} />
        </View>
      </View>

    </Page>
  </Document>
);

const WDSFormModal = ({ setFormView, rowData }) => {
  console.log(rowData)
     const [loader,setLoader]=useState(false)
  const formRef = useRef(null);
  const [pdfBlob, setPdfBlob] = useState(null);
    const [imagesarray,setImagesArray]=useState([])
    const [commentimagesarray,setCommentImagesArray]=useState([])
      const [selectedImage, setSelectedImage] = useState(null);
       const [isModalOpen, setIsModalOpen] = useState(false);
       const [signpreview,setSignPreview]=useState(null)
         const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };
        const closeModal = () => {
    setSelectedImage(null); // Clear the selected image
    setIsModalOpen(false);
  };

  // Extract relevant data from rowData
  const driverName = rowData?.emp_name || 'N/A';
  const unitNumber =
    rowData?.json_data?.find((item) => item.question === 'Driver Information - Unit Number')?.answer || 'N/A';
      const fuelAllocation =
    rowData?.json_data?.find((item) => item.question === 'Driver Information - Fuel Allocation')?.answer || 'N/A';
  const filledDate = rowData?.filled_date || 'N/A';
let pm_sign=rowData?.pm_sign
let pm_status=rowData?.pm_status
const pm_name=rowData?.pm_name
  // Extract log data
  const logData =
    rowData?.json_data?.find((item) => item.question === 'Driver Log Entries')?.answer?.map((log) => ({
      date: log.date || 'N/A',
      mileage_start: log.Start || 'N/A',
      mileage_end: log.End || 'N/A',
      job_number: log.Job || 'N/A',
      repair_fillup_location: log.location || 'N/A',
      gallons_fuel: log.gallons || 'N/A',
      total_amount: log.amount || 'N/A',
      mileage_at_repair_fillup: log.mileage || 'N/A',
    })) || [];

  // Extract safety checks
  const safetyChecks = {};
  rowData?.json_data
    ?.filter((item) => item.question.includes('Vehicle Safety Check'))
    ?.forEach((item) => {
      const checkName = item.question
        .replace(' Vehicle Safety Check (Part-1) - ', '')
        .replace(' Vehicle Safety Check (Part-2) - ', '')
        .trim();
      safetyChecks[checkName] = item.answer;
    });
const fetchImages = async () => {
  try {
    setLoader(true);

    // Collect all filenames safely
    const filenames = [];

    // Add driver signature if available
    if (driverSignature?.[0]?.file_name) {
      filenames.push(driverSignature[0].file_name);
    }

    // Add all comment images if available
    if (Array.isArray(commentimages) && commentimages.length > 0) {
      commentimages.forEach((img) => {
        if (img?.file_name) filenames.push(img.file_name);
      });
    }

    if (filenames.length === 0) {
      console.warn("No filenames to fetch");
      setImagesArray([]);
      setCommentImagesArray([]);
      return;
    }

    // Build query string with encoded filenames
    const queryParams = filenames
      .map((name) => `filenames=${encodeURIComponent(name)}`)
      .join("&");

    // Fetch multiple images from API
    const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);

    if (response.status === 200 && Array.isArray(response?.images)) {
      // Maintain safe order: match API results with requested filenames
      const orderedImages = filenames.map(
        (name) => response.images.find((img) => img.filename === name) || null
      );

      // Separate driverSignature image and comment images
      const driverImage = orderedImages[0] ? [orderedImages[0]] : [];
      const commentImageArray = orderedImages.slice(1).filter(Boolean);

      setImagesArray(driverImage[0]);
      setCommentImagesArray(commentImageArray);
    } else {
      setImagesArray([]);
      setCommentImagesArray([]);
    }

    console.log("Fetched images:", response?.images);
  } catch (error) {
    console.error("Error fetching images:", error);
    setImagesArray([]);
    setCommentImagesArray([]);
  } finally {
    setLoader(false);
  }
};

const checksignatureImage = async (userId) => {
  console.log("Checking signature for user:", userId);

  const cacheBuster = new Date().getTime();
  const signatureUrl = `https://hub2.ntactops.com/ntact/files/user_signatures/${userId}_signature.png?cb=${cacheBuster}`;

  try {
    // Convert the image URL to Base64 via API
    const response = await api.post("/v1/images/to-base64", {
      image_url: signatureUrl,
    });

    if (response.status === 200 && response.data?.base64) {
      const base64String = response.data.base64;

      // ✅ Create base64 data URL for <img>
      const base64Image = `data:image/png;base64,${base64String}`;

      setSignPreview(base64Image); // <-- this updates your state for <img src={signPreview} />
    } else {
      console.warn("Signature not found or invalid response:", response);
      setSignPreview(null);
    }
  } catch (error) {
    console.error("Error fetching signature:", error);
    setSignPreview(null);
  }
};

useEffect(() => {

    fetchImages();

}, []);
useEffect(() => {
  console.log(pm_status, 'ww');

  if (pm_status === 'Y' && pm_sign) {
    // Extract number before underscore
    const match = pm_sign.match(/^(\d+)_/);
    if (match) {
      const numberBeforeUnderscore = match[1];
      console.log('Extracted number:', numberBeforeUnderscore);
      
  checksignatureImage(numberBeforeUnderscore)
      // You can use the extracted number here if needed
    }
  }
;
}, [pm_status]);

  // Extract comments
  const comments = rowData?.json_data?.find((item) => item.question === 'Comments')?.answer || 'No comments provided.';

  // Extract checked by and signature
  const checkedBy = rowData?.json_data?.find((item) => item.question === 'Checked By')?.answer || 'N/A';
  const driverSignature = rowData?.json_data?.find((item) => item.question === 'Signature')?.answer || 'N/A';
const commentimages =
  rowData?.json_data?.find(
    (item) =>
      item.question === "Comments - Uploaded Images" ||
      item.question === "Upload Images"
  )?.answer || "N/A";


  const generatePDF = async () => {
    try {


      const blob = await import('@react-pdf/renderer').then(({ pdf }) =>
        pdf(
          <PDFDocument
            imagesarray={imagesarray}
            driverName={driverName}
            unitNumber={unitNumber}
            filledDate={filledDate}
            logData={logData}
            safetyChecks={safetyChecks}
            comments={comments}
            checkedBy={checkedBy}
            driverSignature={driverSignature}
            commentImageArray={commentimagesarray}
            pm_name={pm_name}
            fuelAllocation={fuelAllocation}
            pm_sign={pm_sign}
            pm_status={pm_status}
            signpreview={signpreview}
       
          />
        ).toBlob()
      );
      setPdfBlob(blob);
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, []);

  const handleBackdropClick = (e) => {
    // Check if the click target is the backdrop itself (not the modal content)
    if (e.target === e.currentTarget) {
      setFormView(false);
    }
  };

  return (
    <div  onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 ">
      <div className="relative w-full max-w-4xl  flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
        <div className="w-full flex justify-between items-end">
          <button
            onClick={generatePDF}
            className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
          >
            Print
          </button>
          <button
            onClick={() => setFormView(false)}
            className="text-gray-600 hover:text-black"
          >
            <CloseIcon />
          </button>
        </div>

        <div ref={formRef} className="w-[90%] mt-4 mx-auto overflow-y-auto custom-scrollbar p-4">
          {/* Form Header */}
          <div className="border-b border-gray-700 pb-2 mb-4">
            <div className="flex w-full justify-between">
              <img src={NtactLogo} alt="NTACT Logo" />
              <div>
                <h2 className="text-lg font-semibold">WEEKLY DRIVER LOG & SAFETY</h2>
              </div>
              <div className="mr-24"></div>
            </div>
          </div>

          {/* Driver Info */}
    {/* Row 1 */}
<div className="grid grid-cols-2 gap-4 mb-4">
  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Driver:</p>
    <p className="text-left font-inter p-1 px-2">{driverName}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>

  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Date:</p>
    <p className="text-left font-inter p-1 px-2">{filledDate}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>
</div>

{/* New separate box */}
<div className="border border-[#9CA3AF] p-1 mb-4">
  <p className="text-sm font-inter font-semibold text-left">
    Fuel Allocation:
  </p>
  <p className="text-left font-inter p-1 px-2 capitalize">
    {fuelAllocation}
  </p>

  <hr className="border-t border-[#9CA3AF]" />

  <p className="text-sm font-inter font-semibold text-left">
    {fuelAllocation === "equipment"
      ? "Equipment Description:"
      : "Unit #:"}
  </p>

  <p className="text-left text-xs font-inter p-1 px-2">
    {unitNumber}
  </p>
</div>


          {/* Log Table */}
          <div className="mb-4">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Date</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage Start</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage End</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Job #</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Repair/Fill-up Location</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Gallons Fuel</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Total Amount</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage @ Repair/Fill-up</th>
                  </tr>
                </thead>
                <tbody>
                  {logData.length > 0 ? (
                    logData.map((log, index) => (
                      <tr key={index}>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.date}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_start}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_end}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.job_number}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.repair_fillup_location}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.gallons_fuel}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.total_amount}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_at_repair_fillup}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="border border-gray-300 p-2 text-sm font-inter text-center">No log data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Note Section */}
          <div className="mb-4 p-4 border border-gray-300 rounded">
            <p className="text-sm font-inter font-semibold text-left mb-2">NOTE:</p>
            <p className="text-sm font-inter text-left">
              Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
            </p>
          </div>

          {/* Safety Checklist */}
          <div className="mb-4">
            <p className="text-sm font-inter font-semibold text-center bg-gray-200 p-2 pb-1 mb-2">
              WEEKLY CHECK (YES = GOOD CONDITION, NO = REQUIRES A COMMENT)
            </p>
            <div className="grid grid-cols-2">
              {[
                'ACCIDENT FORM',
                'BATTERY',
                'BELTS',
                'BRAKE FLUID',
                'ENGINE OIL',
                'FIRE EXTINGUISHER (10lb)',
                'FIRST AID KIT',
                'HEADLAMPS & HI-BEAMS',
                'HEATER HOSES',
                'HITCH, RECEIVER, AND PINS',
                'HORN',
                'INSURANCE CARD',
                'JACK & TIRE IRON',
                'LIGHTS (Parking & BRAKE)',
                'MIRRORS',
                'PARKING BRAKE',
                'RADIATOR FLUID',
                'RADIATOR HOSES',
                'SEATBELTS',
                'SPARE TIRE',
                'STEERING FLUID',
                'TIRE PSI',
                'TRANSMISSION OIL',
                'TURN SIGNALS',
                'WASHER FLUID',
                'WINDSHIELD WIPERS',
              ].map((item, index) => (
                <div key={index} className="flex justify-between items-center px-2 border py-4">
                  <p className="text-sm font-inter text-left">{item}</p>
                  <div className="flex space-x-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name={`${item}-check`}
                        value="YES"
                        checked={safetyChecks[item]?.toUpperCase() === 'YES'}
                    
                        className={`mr-1 ${safetyChecks[item]?.toUpperCase() === 'YES' ? 'accent-green-600' : ''}`}
                      />
                      <span className={safetyChecks[item]?.toUpperCase() === 'YES' ? 'text-green-600 font-bold' : 'text-gray-400'}>YES</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name={`${item}-check`}
                        value="NO"
                        checked={safetyChecks[item]?.toUpperCase() === 'NO'}
                      
                        className={`mr-1 ${safetyChecks[item]?.toUpperCase() === 'NO' ? 'accent-red-600' : ''}`}
                      />
                      <span className={safetyChecks[item]?.toUpperCase() === 'NO' ? 'text-red-600 font-bold' : 'text-gray-400'}>NO</span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>



          {/* Comments Section */}
          <div className="mb-4">
            <div className="text-[16px] my-4 text-left font-semibold">COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)</div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm text-wrap text-gray-700 text-left font-inter py-2 px-3">{comments}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>
<div className="flex flex-wrap gap-4 mt-4 mb-4">
  {commentimagesarray?.map((x, index) => (
    <div
      key={index}
      className="w-44 h-32 flex items-center justify-center border border-gray-300 rounded-lg shadow-md bg-white hover:shadow-lg transition-shadow"
    >
      <img
       onClick={() => openModal(x)}
        src={x?.base64_data}
        alt={`Driver Signature ${index + 1}`}
        className="w-40 h-24 object-contain cursor-pointer"
      />
    </div>
  ))}
</div>


          {/* Signatures */}
          <div className="grid grid-cols-2 gap-4">
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Checked By:</p>
              <p className="text-left font-inter p-1 px-2">{checkedBy}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Driver Signature:</p>
        {imagesarray?.base64_data && (
      <img
        src={imagesarray?.base64_data}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
    )}
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>
                {isModalOpen && selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4"
          // Close modal when clicking on the background overlay
          onClick={closeModal}
        >
          <div
            className="relative bg-white rounded-lg shadow-xl p-2 md:p-4 max-w-4xl max-h-[90vh] flex justify-center items-center"
            // Prevent clicks on the image/content area from closing the modal
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage?.preview?.base64_data|| selectedImage?.base64_data}
              alt={''}
              className="max-w-full max-h-full object-contain" // Use object-contain to fit image within bounds
            />

            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-white bg-gray-800 rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold opacity-75 hover:opacity-100 transition-opacity"
              onClick={closeModal}
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>
        </div>
      )}
         {/* {signpreview?  <div className="grid grid-cols-2 gap-4">
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Signed By: Project Manager</p>
              <p className="text-left font-inter p-1 px-2">{pm_name}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left"> Signature:</p>
       
      <img
        src={signpreview}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
   
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>:<></>} */}
   
        </div>
      </div>
      <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
    </div>
  );
};

export default WDSFormModal;